<ng-select #select
           [attr.aria-label]="controlLabel"
           [class.cursor-text]="isSearchable"
           [class.disabled]="isDisabled"
           (add)="onAdd($event)"
           [addTag]="canAddCustom ? formatCustom : false"
           [bindLabel]="label"
           [bindValue]="value"
           (blur)="onBlur($event)"
           (change)="onChange($event)"
           (clear)="onClear()"
           [clearable]="isClearable"
           [clearOnBackspace]="false"
           (close)="onClose()"
           (focus)="onFocus($event)"
           [items]="loadedData"
           [loading]="isLoading"
           [multiple]="isMultiSelect"
           [(ngModel)]="model"
           (open)="onOpen()"
           [placeholder]="placeholderText"
           (remove)="onRemove($event)"
           (search)="onSearch($event)"
           [searchable]="isSearchable"
           [virtualScroll]="hasVirtualScroll">
    <ng-template *ngIf="optionTemplate" ng-option-tmp let-item="item">
        <!--
            Example usage (include as child element of mc-select-ng)
                <ng-template ng-option-tmp let-item="item">
                    {{ item.id }}
                </ng-template>
        -->
        <ng-template [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{item: item}"></ng-template>
    </ng-template>
</ng-select>
